import { FRAME_ID } from '../constants';
import type { CreditCardFormHostTokenizeProps } from './CreditCardFormHost.types';

export const injectTokenizeRequest = (
  _ref?: CreditCardFormHostTokenizeProps['ref'],
) => {
  const frame = document.querySelector(`#${FRAME_ID}`);

  if (!frame) return;

  const withContentWindow = frame as unknown as {
    readonly contentWindow: { readonly tokenizeCreditCard: () => void };
  };

  withContentWindow.contentWindow.tokenizeCreditCard();
};
